import React, {FC} from "react"

import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"

interface Props {
  load: Promise<void> | null
}

const PriceLoader: FC<Props> = ({load}) => {
  const theme = useTheme()
  return (
    <Flex alignItems="center" justifyContent="space-evenly" marginTop={1} width="100%" height="410px">
      <div>
        <Loading load={load} />
      </div>
      <Body small color={theme.colors.greys.white}>
        <FormattedMessage id="admin.billing.renewals.newPlan.loading" />
      </Body>
    </Flex>
  )
}

export default PriceLoader
